import React from 'react';
import DestinationTemplate from '../../components/DestinationTemplate';

const JordanPage = () => {
  return <DestinationTemplate destinationId="jordan" />;
};

export default JordanPage;
